module.exports = __webpack_public_path__ + "static/media/convective-icon-marginal.e66ad0ac.svg";